import { render, staticRenderFns } from "./investments.vue?vue&type=template&id=7534924c"
import script from "./investments.vue?vue&type=script&lang=js"
export * from "./investments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports